import { type List, Record } from "immutable";

import { TicketModel } from "./TicketModel";

const defaults = {
  content: "",
  createdAt: new Date(0),
  creatorId: null as null | string,
  id: "",
  isDeleted: false,
  replies: null as List<TicketCommentModel> | null,
  ticket: null as null | TicketModel,
  updatedAt: new Date(0),
};

export class TicketCommentModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown): TicketCommentModel {
    const { content, createdAt, creatorId, id, isDeleted, replies, ticket, updatedAt } = data as typeof defaults;

    return new TicketCommentModel({
      content,
      createdAt: new Date(createdAt),
      creatorId: creatorId || null,
      id,
      isDeleted,
      replies: replies ? replies.map(TicketCommentModel.fromServerData) : null,
      ticket: ticket ? TicketModel.fromServerData(ticket) : null,
      updatedAt: new Date(updatedAt),
    });
  }
}
